"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = require("react");
var _analytics = _interopRequireDefault(require("@xto10x/core/lib/analytics"));
var _configApi = _interopRequireDefault(require("@xto10x/core/lib/configApi"));
var _indexedDB = _interopRequireDefault(require("./indexedDB"));
var _localStorage = _interopRequireDefault(require("./localStorage"));
var _cookieUtil = _interopRequireDefault(require("./utils/cookieUtil"));
var ANALYTICS_CATEGORY = 'config_service';
var STORAGES_ENABLED = {
  idb: true,
  local: true
};
var appConfig = function appConfig(appName) {
  var _useState = (0, _react.useState)("".concat(appName, "-appConfig")),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 1),
    identifier = _useState2[0];
  var _useState3 = (0, _react.useState)(null),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    configCachePresent = _useState4[0],
    setConfigCachePresent = _useState4[1];
  var _useState5 = (0, _react.useState)(null),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    configStore = _useState6[0],
    setConfigStore = _useState6[1];
  var _useState7 = (0, _react.useState)(null),
    _useState8 = (0, _slicedToArray2["default"])(_useState7, 2),
    config = _useState8[0],
    setConfig = _useState8[1];
  (0, _react.useEffect)(function () {
    if (_cookieUtil["default"].getCookie(identifier).cookieExists) setConfigCachePresent(true);else setConfigCachePresent(false);
  }, [identifier]);
  (0, _react.useEffect)(function () {
    if (STORAGES_ENABLED.idb && _indexedDB["default"].support.isSupported()) return setConfigStore('IDB');
    if (STORAGES_ENABLED.local && _localStorage["default"].isSupported()) return setConfigStore('LOCAL');
    _analytics["default"].trackError(ANALYTICS_CATEGORY, new Error('IDB AND LOCAL config stores are not supported.'));
    return setConfigStore('DEFAULT');
  }, []);
  var _getAppConfig = function getAppConfig() {
    var retry = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
    return _configApi["default"].getPublicConfig(appName).then(function (_ref) {
      var data = _ref.data.data;
      var config = {};
      data.forEach(function (c) {
        return config[c.configName] = c.data;
      });
      return config;
    })["catch"](function (e) {
      if (retry) return _getAppConfig(false);
      throw e;
    });
  };
  var setIDBCache = function setIDBCache(data, db) {
    return _indexedDB["default"].transaction.addData(db, identifier, identifier.concat('-data'), data).then(function (_ref2) {
      var status = _ref2.status;
      db.close();
      if (status === 200) _cookieUtil["default"].createCookie(identifier, '1', 1);
    })["catch"](function (err) {
      if (err.status && err.status === 400 && err.message === 'Entry already exists') _indexedDB["default"].transaction.updateData(db, identifier, identifier.concat('-data'), data).then(function (_ref3) {
        var status = _ref3.status;
        db.close();
        if (status === 200) _cookieUtil["default"].createCookie(identifier, '1', 1);
      })["catch"](function () {
        return null;
      });
    });
  };
  var connectAndCacheDataInIDB = function connectAndCacheDataInIDB(data) {
    var conn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!conn) _indexedDB["default"].initializeAndConnect([identifier]).then(function (db) {
      return setIDBCache(data, db);
    });else setIDBCache(data, conn);
  };
  var cacheDataInLocal = function cacheDataInLocal(data) {
    _localStorage["default"].addItem(identifier, data);
    _cookieUtil["default"].createCookie(identifier, '1', 1);
  };
  (0, _react.useEffect)(function () {
    if (configCachePresent === null || configStore === null) return;
    if (configCachePresent && configStore !== 'DEFAULT') {
      switch (configStore) {
        case 'IDB':
          try {
            _indexedDB["default"].initializeAndConnect([identifier]).then(function (db) {
              return _indexedDB["default"].transaction.getData(db, identifier, identifier.concat('-data')).then(function (_ref4) {
                var status = _ref4.status,
                  data = _ref4.data;
                db.close();
                if ((0, _typeof2["default"])(data) !== 'object') throw new Error({
                  status: 404
                });
                if (status === 200) {
                  setConfig(data);
                  _analytics["default"].trackEvent(ANALYTICS_CATEGORY, 'idb_cache_hit');
                }
              })["catch"](function (err) {
                db.close();
                if (err.status && [404, 500].indexOf(err.status) !== -1) {
                  _getAppConfig().then(function (c) {
                    setConfig(c);
                    connectAndCacheDataInIDB(c);
                    _analytics["default"].trackEvent(ANALYTICS_CATEGORY, 'invalid_config_data_idb_cache_update');
                  })["catch"](function () {
                    return null;
                  });
                }
              });
            });
          } catch (err) {
            //
          }
          break;
        case 'LOCAL':
          // eslint-disable-next-line no-case-declarations
          var data = _localStorage["default"].getItem(identifier);
          if (!data && (0, _typeof2["default"])(data) !== 'object') {
            _getAppConfig().then(function (c) {
              setConfig(c);
              cacheDataInLocal(c);
              _analytics["default"].trackEvent(ANALYTICS_CATEGORY, 'invalid_config_data_local_cache_update');
            })["catch"](function () {
              return null;
            });
            return;
          }
          setConfig(data);
          _analytics["default"].trackEvent(ANALYTICS_CATEGORY, 'local_cache_hit');
          break;
        default:
          break;
      }
    } else {
      _getAppConfig().then(function (data) {
        setConfig(data);
        switch (configStore) {
          case 'IDB':
            _getAppConfig().then(function (c) {
              connectAndCacheDataInIDB(c);
              _analytics["default"].trackEvent(ANALYTICS_CATEGORY, 'idb_cache_install');
            })["catch"](function () {
              return null;
            });
            break;
          case 'LOCAL':
            _getAppConfig().then(function (c) {
              cacheDataInLocal(c);
              _analytics["default"].trackEvent(ANALYTICS_CATEGORY, 'local_cache_install');
            })["catch"](function () {
              return null;
            });
            break;
          default:
            break;
        }
      })["catch"](function () {
        return null;
      });
    }
  }, [identifier, configCachePresent, configStore]);
  return config;
};
var _default = exports["default"] = appConfig;